













































































































































































import { Vue, Component } from "vue-property-decorator";
import {
  getActivityRosterListApi,
  getActivitySelectTypeListApi,
  getActivitySelectListApi,
  getMarketStaffListApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "promotionList",
  components: {
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {};
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  tableData: any[] = [];
  activityTypeList: any[] = [];
  activityTitleList: any[] = [];
  market_staff_list: any[] = [];
  timer: any = "";
  effectiveDate: any = {
    disabledDate(date: any) {
      return date > Date.now();
    },
  };

  created() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
    this.getActivietySelectTypeList();
    this.getActivitySelectList();
    this.getMarketStaffListApiFn();
  }
  solveSearchInfo(option: any) {
    let params = { ...option };
    if (this.searchInfo.keyword) {
      params.keyword = this.searchInfo.keyword;
    }
    if (this.searchInfo.type_id) {
      params.type_id = this.searchInfo.type_id;
    }
    if (this.searchInfo.activity_id) {
      params.activity_id = this.searchInfo.activity_id;
    }
    if (this.$route.query.market_staff_id !== "") {
      params.market_staff_id = this.$route.query.market_staff_id;
    }
    if (this.searchInfo.staff_id) {
      params.market_staff_id = this.searchInfo.staff_id;
    }
    if (this.searchInfo.create_time) {
      params.create_start_time =
        new Date(this.searchInfo.create_time[0] + " 00:00:01").getTime() / 1000;
      params.create_end_time =
        new Date(this.searchInfo.create_time[1] + " 23:59:59").getTime() / 1000;
    }
    return params;
  }
  getList(params?: any) {
    let option = this.solveSearchInfo(params);
    if (Number(this.$route.query.market_staff_id) === 0) {
      option.is_official = 1;
    }
    getActivityRosterListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.forEach((item: any, index: any) => {
          item.create_time = item.create_time
            ? dateFormat("YYYY-mm-dd HH:MM", item.create_time * 1000)
            : "-";
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  // 获取市场顾问列表
  getMarketStaffListApiFn(v?: any) {
    getMarketStaffListApi({
      page: 1,
      page_size: 100,
      keyword: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.market_staff_list = res.data.list;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  // 模糊搜索 - 市场顾问
  handleSearchMarketStaff(v: any) {
    this.debounce(this.getMarketStaffListApiFn, v, 500);
  }
  debounce(fn: any, data: any, delay: any) {
    // 设置一个触发开关
    let _t = this;
    clearTimeout(_t.timer);
    _t.timer = setTimeout(() => {
      fn(data);
    }, delay);
  }
  // 活动名称列表
  getActivitySelectList(v?: any) {
    getActivitySelectListApi({
      page: 1,
      page_size: 100,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.activityTitleList = res.data.list;
      }
    });
  }
  // 活动类型列表
  getActivietySelectTypeList(v?: any) {
    getActivitySelectTypeListApi({
      page: 1,
      page_size: 100,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.activityTypeList = res.data.list;
      }
    });
  }
  // 模糊搜索 - 活动名称
  handleSearchTitle(v: any) {
    this.getActivitySelectList(v);
  }
  // 模糊搜索 - 活动类型
  handleSearchType(v: any) {
    this.getActivietySelectTypeList(v);
  }
  // 列表下拉
  handleVisible(v: any) {
    if (v) {
      this.getActivietySelectTypeList();
      this.getActivitySelectList();
    }
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  handleBack() {
    this.$router.push({
      name: "marketingPromotion",
    });
  }
}
